
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function ProfileEdit() {
    AnimationFileLoader();

    return (
      <>
     
    
      {/* Author */}
    <div className="author-area">
        <div className="author-cover author-cover-edit" data-bg-img="/img/bg/author-cover.png">
            <span className="upload-btn">
                <img src="/img/icons/plus.svg" className="svg" alt=""/>
                <input type="file" accept="image/*" />
            </span>
        </div>
        <div className="author-info">
            {/* Breadcrumb */}
            <div className="breadcrumb d-none justify-content-end">
                <ul className="nav">
                    <li><NavLink to="/home/home-v1">Home</NavLink></li>
                    <li className="active"><NavLink to="/pages/profile-edit">Edit Profile</NavLink></li>
                </ul>
            </div>
            {/* End Breadcrumb */}
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        {/* Profile */}
                        <div className="author-profile text-center d-inline-block">
                            <div className="user-avatar">
                                <img src="/img/media/profile-avatar.png" alt=""/>
                                <span className="upload-btn">
                                    <img src="/img/icons/plus.svg" className="svg" alt=""/>
                                    <input type="file" accept="image/*" />
                                </span>
                            </div>

                            <h5 className="user_name text-white">AneftyPunks</h5>
                        </div>
                        {/* End Profile */}
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* End Author */}

    {/* Breadcrumb */}
    <div className="page-title-wrap ovx-hidden d-none" data-bg-img="/img/bg/page-title-bg.png">
        <div className="container">
            <div className="row align-items-center">
                <div className="col">
                    <div className="page-title text-center">
                        <h2>About Us</h2>
                        <ul className="nav justify-content-center">
                            <li><NavLink to="/home/home-v1" ><i className="fas fa-home"></i> Home</NavLink></li>
                            <li className="active">About Us</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* End Breadcrumb */}

    {/* Account Information */}
    <section className="pt-120 pb-120 mt-n1">
        <div className="container">
            <div className="row">
                <div className="col-md-8">
                    {/* Section Title */}
                    <div className="section-title">
                        <h2 className="text-white">Profile Setting</h2>
                    </div>
                    {/* End Section Title */}
                </div>
                <div className="col-md-4">
                    <div className="d-flex justify-content-md-end mb-5 mb-md-0">
                        <NavLink to="pages/profile" className="btn btn-border style-c1">see Previws</NavLink>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <form action="#" className="edit-profile-form text-white">
                        <div className="card mb-60">
                            <div className="card-body">
                                <div className="profile-images">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            {/* Profile img Edit */}
                                            <div className="profile-edit mb-5 mb-lg-0">
                                                <h3>Profile Image</h3>
                                                <div className="author-cover author-cover-edit">
                                                    <img src="/img/media/profile-edit.png" alt=""/>
                                                    <span className="upload-btn">
                                                        <img src="/img/icons/plus.svg" className="svg" alt=""/>
                                                        <input type="file" accept="image/*" />
                                                    </span>
                                                </div>
                                            </div>
                                            {/* End Profile img Edit */}
                                        </div>
                                        <div className="col-lg-6">
                                            {/* Profile Cover Edit */}
                                            <div className="profile-cover-edit">
                                                <h3>Profile Banner</h3>
                                                <div className="author-cover author-cover-edit">
                                                    <img src="/img/media/profile-edit2.png" alt=""/>
                                                    <span className="upload-btn">
                                                        <img src="/img/icons/plus.svg" className="svg" alt=""/>
                                                        <input type="file" accept="image/*" />
                                                    </span>
                                                </div>
                                            </div>
                                            {/* End Profile Cover Edit */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card mb-60">
                            <div className="card-body">
                                <div className="account-info">

                                    <h3>Account Information</h3>
                                    <div className="form-group">
                                        <label htmlFor="name">Display Name</label>
                                        <input type="text" className="form-control" id="name"
                                            placeholder="Example @alex_anderson " />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="custom-url">Custom URL</label>
                                        <input type="url" className="form-control" id="custom-url"
                                            placeholder="Example @www.anefty.com/" />
                                    </div>
                                    <div className="form-group">
                                        <div className="row justify-content-between">
                                            <label htmlFor="email" className="col-md-5">eMail Address</label>
                                            <span className="info col-md-7 d-flex justify-content-md-end mb-3 mb-lg-0">*
                                                Your email
                                                htmlFor
                                                marketplace
                                                notifications</span>
                                        </div>
                                        <input type="email" className="form-control" id="email"
                                            placeholder="Example @support.anefty@gmail.com" />
                                        <button className="btn btn-sm" type="button">
                                            <img src="/img/icons/btn-check.svg" alt="" className="svg"/> Confirm
                                        </button>
                                    </div>
                                    <div className="form-group mb-0">
                                        <label htmlFor="bio">Bio</label>
                                        <textarea id="bio" className="form-control mb-0"
                                            placeholder="Write your bio"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="social-media">

                                    <h3>Social Media</h3>
                                    <div className="form-group">
                                        <label htmlFor="facebook">Facebook Account</label>
                                        <input type="text" className="form-control" id="facebook"
                                            placeholder="Example @anefty_alexder" />

                                        <button className="btn btn-sm" type="button">
                                            <img src="/img/icons/btn-fb.svg" alt="" className="svg"/> Connect
                                            Facebook
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="twitter">Twitter Account</label>
                                        <input type="text" className="form-control" id="twitter"
                                            placeholder="Example @anefty_alexder"/>

                                        <button className="btn btn-sm" type="button">
                                            <img src="/img/icons/btn-twitter.svg" alt="" className="svg"/> Connect
                                            Twitter
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="tiktok">Tiktok Account</label>
                                        <input type="text" className="form-control" id="tiktok"
                                            placeholder="Example @anefty_alexder"/>

                                        <button className="btn btn-sm" type="button">
                                            <img src="/img/icons/btn-tiktok.svg" alt="" className="svg"/> Connect
                                            Tiktok
                                        </button>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <button type="submit" className="btn">
                                            <img src="/img/icons/btn-save.svg" className="svg" alt=""/>
                                            Save Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
    {/* End Account Information */}

    </>
  );
}

export default ProfileEdit;
